export default __webpack_public_path__ + "static/media/predictionbox.6ce51e2d.svg";